import React, { useState } from "react";
import {
  KoText, KoAvatar,
  KoButton,
  KoImage
} from "packages";
import KoIcon from '@kwapio/icons';
import PhoneInput from "antd-phone-input";
import styles from './settings.module.scss';
import CustomerDetails from "./customerview";

function Preview(props) {
  const { settings, getByIdSettings } = props;
  const [openSettingsModal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState(1);
  return (
    <div className={styles.tabs} >
      <div className={styles.previewWrapper}>
        <div className={styles.cardWrapper}>
          <div className={styles.cardHeader}>
            <KoText className={styles.headingText} text={'Business Details'} />
            <KoButton icon={<KoIcon width={16} height={16} name={'EditOutlined'} />} className={styles.actionBtn} onClick={() => {setActiveTab(1); setModal(true);}} label="" />
          </div>
          <div className={styles.card}>
            <div className={styles.fieldList}>
              <div className={styles.viewMode}>
                <KoText className={styles.title} text={''} />
                <div className={styles.saveAction}>
                  <div className={styles.upload}>
                    <div className={styles.picture}>
                      {settings?.logo ? <KoImage preview={false} src={settings?.logo[0].url} /> :
                        <KoIcon name="Avatar1Filled" width={115} height={25} />}
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.viewMode}>
                <KoText className={styles.title} text={'Company Name'} />
                <KoText className={styles.titleValue} text={settings?.companyName} />
              </div>
              <div className={styles.viewMode}>
                <KoText className={styles.title} text={'Website'} />
                <KoText className={styles.titleValue} text={settings?.url} />
              </div>
              <div className={styles.viewMode}>
                <KoText className={styles.title} text={'GST Number'} />
                <KoText className={styles.titleValue} text={settings?.GST} />
              </div>
              <div className={styles.viewMode}>
                <KoText className={styles.title} text={'PAN Number'} />
                <KoText className={styles.titleValue} text={settings?.PAN} />
              </div>
              <div className={styles.viewMode}>
                <KoText className={styles.title} text={'UAN Number'} />
                <KoText className={styles.titleValue} text={settings?.UAN} />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.cardWrapper}>
          <div className={styles.cardHeader}>
            <KoText className={styles.headingText} text={'Business Primary Contact'} />
            <KoButton icon={<KoIcon width={16} height={16} name={'EditOutlined'} />} className={styles.actionBtn} onClick={() => {setActiveTab(2); setModal(true);}} label="" />
          </div>
          <div className={styles.card}>
            <div className={styles.contactList}>
              <div className={styles.viewMode}>
                <KoText className={styles.title} text={'Name'} />
                <div className={styles.profileName}>
                  <KoAvatar inLine={'0rem'} options={[{ name: settings?.firstName }]} size={30} />
                  {settings?.firstName && <div className={styles.userInfo}>
                    <KoText className={styles.nameText} text={`${settings?.firstName} ${settings?.lastName}`} />
                    <KoText className={styles.designationText} text={settings?.designation} />
                  </div>}
                </div>
              </div>
              <div className={styles.viewMode}>
                <KoText className={styles.title} text={'Phone Number'} />
                <div className={styles.contacts}>
                  <div className={styles.circle}>
                    <KoIcon name="PhoneOutlined" height={12} width={12} />
                  </div>
                  {settings?.mobile && <PhoneInput className='mobileNo' disableDropdown readOnly value={settings?.mobile} />}
                </div>
              </div>
              <div className={styles.viewMode}>
                <KoText className={styles.title} text={'Email Address'} />
                <div className={styles.contacts}>
                  <div className={styles.circle}>
                    <KoIcon name="EmailOutlined" height={14} width={14} />
                  </div>
                  <KoText className={styles.nameText} text={settings?.email} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.cardWrapper}>
          <div className={styles.cardHeader}>
            <KoText className={styles.headingText} text={'Business Secondary Contact'} />
            <KoButton icon={<KoIcon width={16} height={16} name={'EditOutlined'} />} className={styles.actionBtn} onClick={() => {setActiveTab(2); setModal(true);}} label="" />
          </div>
          <div className={styles.card}>
            <div className={styles.contactList}>
              <div className={styles.viewMode}>
                <KoText className={styles.title} text={'Name'} />
                <div className={styles.profileName}>
                  <KoAvatar inLine={'0rem'} options={[{ name: settings?.alternativeContact?.firstName }]} size={30} />
                  {settings?.alternativeContact?.firstName && <div className={styles.userInfo}>
                    <KoText className={styles.nameText} text={`${settings?.alternativeContact?.firstName} ${settings?.alternativeContact?.lastName}`} />
                    <KoText className={styles.designationText} text={settings?.alternativeContact?.designation} />
                  </div>}
                </div>
              </div>
              <div className={styles.viewMode}>
                <KoText className={styles.title} text={'Phone Number'} />
                <div className={styles.contacts}>
                  <div className={styles.circle}>
                    <KoIcon name="PhoneOutlined" height={12} width={12} />
                  </div>
                  {settings?.mobile && <PhoneInput className='mobileNo' disableDropdown readOnly value={settings?.alternativeContact?.mobile} />}
                </div>
              </div>
              <div className={styles.viewMode}>
                <KoText className={styles.title} text={'Email Address'} />
                <div className={styles.contacts}>
                  <div className={styles.circle}>
                    <KoIcon name="EmailOutlined" height={14} width={14} />
                  </div>
                  <KoText className={styles.nameText} text={settings?.alternativeContact?.email} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.cardWrapper}>
          <div className={styles.cardHeader}>
            <KoText className={styles.headingText} text={'General Preferences'} />
            <KoButton icon={<KoIcon width={16} height={16} name={'EditOutlined'} />} className={styles.actionBtn} onClick={() => {setActiveTab(3); setModal(true);}} label="" />
          </div>
          <div className={styles.card}>
            <div className={styles.fieldList}>
              <div className={styles.viewMode}>
                <KoText className={styles.title} text={'Default Language'} />
                <KoText className={styles.titleValue} text={settings?.preferences?.defaultLanguage} />
              </div>
              <div className={styles.viewMode}>
                <KoText className={styles.title} text={'Primary Currency'} />
                <KoText className={styles.titleValue} text={settings?.preferences?.primaryCurrency} />
              </div>
              <div className={styles.viewMode}>
                <KoText className={styles.title} text={'Number Format'} />
                <KoText className={styles.titleValue} text={settings?.preferences?.numberFormat} />
              </div>
              <div className={styles.viewMode}>
                <KoText className={styles.title} text={'Date Format'} />
                <KoText className={styles.titleValue} text={settings?.preferences?.dateFormat} />
              </div>
              <div className={styles.viewMode}>
                <KoText className={styles.title} text={'Time Format'} />
                <KoText className={styles.titleValue} text={settings?.preferences?.timeFormat} />
              </div>
              <div className={styles.viewMode}>
                <KoText className={styles.title} text={'Financial Year Begins'} />
                <KoText className={styles.titleValue} text={settings?.preferences?.financialYearBegins} />
              </div>
              <div className={styles.viewMode}>
                <KoText className={styles.title} text={'Invoice No. Prefix'} />
                <KoText className={styles.titleValue} text={settings?.preferences?.invoiceNoPrefix} />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.cardWrapper}>
          <div className={styles.cardHeader}>
            <KoText className={styles.headingText} text={'Address'} />
            <KoButton icon={<KoIcon width={16} height={16} name={'EditOutlined'} />} className={styles.actionBtn} onClick={() => {setActiveTab(4); setModal(true);}} label="" />
          </div>
          <div className={styles.card}>
            <div className={styles.fieldListOne}>
              <div className={styles.viewMode}>
                <KoText className={styles.title} text={'AddressLine1'} />
                <KoText className={styles.titleValue} ellipse={true} text={settings?.address?.addressLine1} />
              </div>
              <div className={`${styles.viewMode} ${styles.viewMode2}`}>
                <KoText className={styles.title}  ellipse={true} text={'AddressLine2'} />
                <KoText className={styles.titleValue} text={settings?.address?.addressLine2} />
              </div>
            </div>
            <div className={styles.fieldList}>
              <div className={styles.viewMode}>
                <KoText className={styles.title} text={'City'} />
                <KoText className={styles.titleValue} text={settings?.address?.city} />
              </div>
              <div className={styles.viewMode}>
                <KoText className={styles.title} text={'State'} />
                <KoText className={styles.titleValue} text={settings?.address?.state} />

              </div>
              <div className={styles.viewMode}>
                <KoText className={styles.title} text={'Country'} />
                <KoText className={styles.titleValue} text={settings?.address?.country} />
              </div>
              <div className={styles.viewMode}>
                <KoText className={styles.title} text={'Pincode'} />
                <KoText className={styles.titleValue} text={settings?.address?.pincode} />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.cardWrapper}>
          <div className={styles.cardHeader}>
            <KoText className={styles.headingText} text={'Bank Details'} />
            <KoButton icon={<KoIcon width={16} height={16} name={'EditOutlined'} />} className={styles.actionBtn} onClick={() => {setActiveTab(5); setModal(true);}} label="" />
          </div>
          <div className={styles.card}>
            <div className={styles.fieldList}>
              <div className={styles.viewMode}>
                <KoText className={styles.title} text={'Account Name'} />
                <KoText className={styles.titleValue} text={settings?.bank?.accountName} />
              </div>
              <div className={styles.viewMode}>
                <KoText className={styles.title} text={'Bank Name'} />
                <KoText className={styles.titleValue} text={settings?.bank?.bankName} />
              </div>
              <div className={styles.viewMode}>
                <KoText className={styles.title} text={'IFSC Code'} />
                <KoText className={styles.titleValue} text={settings?.bank?.ifscCode} />
              </div>
              <div className={styles.viewMode}>
                <KoText className={styles.title} text={'Swipe code'} />
                <KoText className={styles.titleValue} text={settings?.bank?.swipeCode} />
              </div>
              <div className={styles.viewMode}>
                <KoText className={styles.title} text={'Account No'} />
                <KoText className={styles.titleValue} text={settings?.bank?.accountNo} />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.cardWrapper}>
          <div className={styles.cardHeader}>
            <KoText className={styles.headingText} text={'Tax Details'} />
            <KoButton icon={<KoIcon width={16} height={16} name={'EditOutlined'} />} className={styles.actionBtn} onClick={() => {setActiveTab(6); setModal(true);}} label="" />
          </div>
          <div className={styles.card}>
            {settings?.tax?.map((tax, i) =>
              <div className={styles.fieldList} key={i}>
                <div className={styles.viewMode}>
                  {i === 0 && <KoText className={`${styles.title} ${styles.padding}`} text={'Tax Name'} />}
                  <KoText className={`${styles.titleValue} ${styles.padding}`} text={tax?.taxName} />
                </div>
                <div className={styles.viewMode}>
                  {i === 0 && <KoText className={`${styles.title} ${styles.padding}`} text={'Tax Rate'} />}
                  <KoText className={`${styles.titleValue} ${styles.padding}`} text={tax?.taxRate + '%'} />
                </div>
                <div className={styles.viewMode}>
                  {i === 0 && <KoText className={`${styles.title} ${styles.padding}`} text={'Default Tax'} />}
                  <KoText className={`${styles.titleValue} ${styles.padding}`} text={tax?.isDefault ? 'Yes' : 'No'} />
                </div>
              </div>
            )}
          </div>
        </div>
        <div className={styles.cardWrapper}>
          <div className={styles.cardHeader}>
            <KoText className={styles.headingText} text={'Discount Details'} />
            <KoButton icon={<KoIcon width={16} height={16} name={'EditOutlined'} />} className={styles.actionBtn} onClick={() => {setActiveTab(7); setModal(true);}} label="" />
          </div>

          <div className={styles.card}>
            {settings?.discount?.map((discount, i) =>
              <div className={styles.fieldList} key={i}>
                <div className={styles.viewMode}>
                  {i === 0 && <KoText className={`${styles.title} ${styles.padding}`} text={'Discount Name'} />}
                  <KoText className={`${styles.titleValue} ${styles.padding}`} text={discount?.discountName} />
                </div>
                <div className={styles.viewMode}>
                  {i === 0 && <KoText className={`${styles.title} ${styles.padding}`} text={'Discount Rate'} />}
                  <KoText className={`${styles.titleValue} ${styles.padding}`} text={discount?.discountRate + '%'} />
                </div>
                <div className={styles.viewMode}>
                  {i === 0 && <KoText className={`${styles.title} ${styles.padding}`} text={'Default Discount'} />}
                  <KoText className={`${styles.titleValue} ${styles.padding}`} text={discount?.isDefault ? 'Yes' : 'No'} />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {openSettingsModal&& <CustomerDetails activeTab={activeTab} setActiveTab={setActiveTab} settings={settings} getByIdSettings={getByIdSettings} openCustomerModal={openSettingsModal} setOpenCustomerModal={() => setModal(false)} />}

    </div>
  );
}

export default Preview;